import React, { useState } from "react";

export const ShopListContext = React.createContext();
export const ShopListProvider = ({ children }) => {
  const [shopList, setShopList] = useState(null);

  const setShopListHandler = (menuItem) => {
    setShopList(menuItem);
  };

  return (
    <ShopListContext.Provider value={{ shopList, setShopListHandler }}>
      {children}
    </ShopListContext.Provider>
  );
};

export const ShopContext = React.createContext();
export const ShopProvider = ({ children }) => {
  const [shopData, setShopData] = useState(null);

  const setShopDataHandler = (menuItem) => {
    setShopData(menuItem);
  };

  return (
    <ShopContext.Provider value={{ shopData, setShopDataHandler }}>
      {children}
    </ShopContext.Provider>
  );
};
